module.exports = __webpack_public_path__ + "img/cannabis.37cd653d.svg";